import { AccountMenu } from "./AccountMenu";

// The masthead account control (sign in / chip + menu).
export function AccountSlot() {
  return <AccountMenu />;
}
